<template>
  <app-panel
    class="hidden lg:block"
    data-cy-application
    title="Événement passé"
  >
    <template #footer>
      <event-replay-cta block color="dark" :event="event" size="lg" />
    </template>
  </app-panel>

  <teleport to="body">
    <app-bottom-sheet class="lg:hidden">
      <event-replay-cta block color="dark" :event="event" size="lg" />
    </app-bottom-sheet>
  </teleport>
</template>

<script lang="ts" setup>
import type { EventView } from "~/business-areas/event/composables/event-view.hook";

defineProps<{
  event: EventView;
}>();
</script>
